module.exports = __webpack_public_path__ + "img/0-02-0a-a8a5576d0abb5411273a4223f097a5239c034a76992e3db9d3d0820d7c234a02_53a61ab2.71d07360.jpg";